import { AxiosResponse } from 'axios';
import { InfoDto } from '@partnerka-front/types';
import { $api } from './index';

const basePath = '/info';

export async function getInfo(site_page: string): Promise<AxiosResponse<InfoDto[]>> {
  return $api.get(`${basePath}/${site_page}/`);
}
